import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  fieldsContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    alignItems: 'center',
    columnGap: 16,
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr 1fr',
      columnGap: 8
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr'
    }
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%'
  },
  showProviderContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}))

export default useStyles
